import httpClient from "@/store/httpClient";
export default {
    async sendMail(context, payload) {
         await httpClient.post("/quartiersentwicklung/send-mail", payload);
    }
}
